import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import VendorRegistrationForm from '../Vendor-form';
import { VendorAprovedGetsingle } from '../../../../../services/api/vendor';

export default function VendorEditFrom() {
	const { id } = useParams();
	const [initialData, setIntialData] = useState(null);
	const FetchData = async () => {
		try {
			const response = await VendorAprovedGetsingle(id);
			console.log(response, 'response');
			if (response.success) {
				setIntialData(response.data.vendor);
			}
		} catch (error) {}
	};
	useEffect(() => {
		FetchData();
	}, []);
	return (
		<>
			<VendorRegistrationForm
				initialData={initialData}
				isEdit={id}
				// onSubmit={async (formData: any) => {
				// 	console.log(formData);
				// 	// Call your update API here
				// 	const res = await VendorEditforms(formData, id);
				// 	if (res.success) alert('Vendor updated!');
				// }}
				// onCancel={() => {
				// 	alert('demo');
				// 	window.history.back();
				// 	// close modal or go back
				// }}
			/>
		</>
	);
}
